/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { makeFullPath } from 'apmui/resource/Model';
import { IResourceProps } from 'apmui/resource/ResourceLoader';
import RESOURCE from 'apmui/resource/ResourceType';
import WebtopResourceModel from 'apmui/resource/WebtopResourceModel';
import { isFavoriteVisited } from './VisitedFavorites';

/* mcp: remote_desktop_type_t */
enum REMOTE_DESKTOP_TYPE {
    NONE = 'none' /* mcp: REMOTE_DESKTOP_TYPE_NONE */,
    CITRIX = 'citrix' /* mcp: REMOTE_DESKTOP_TYPE_CITRIX */,
    RDP = 'rdp' /* mcp: REMOTE_DESKTOP_TYPE_RDP */,
    VMWARE_VIEW = 'vmware_view' /* mcp: REMOTE_DESKTOP_TYPE_VMWARE_VIEW */,
}

interface IIcons {
    icon: string;
    iconError: string;
}

const REMOTE_DESKTOP_TYPE_ICONS: { [rdType in REMOTE_DESKTOP_TYPE]: IIcons } = {
    [REMOTE_DESKTOP_TYPE.NONE]: {
        icon: '',
        iconError: '',
    },
    [REMOTE_DESKTOP_TYPE.CITRIX]: {
        icon: makeFullPath('icon-rd-ctx.png'),
        iconError: makeFullPath('icon-rd-ctx-error.png'),
    },
    [REMOTE_DESKTOP_TYPE.RDP]: {
        icon: makeFullPath('icon-rd-ms.png'),
        iconError: makeFullPath('icon-rd-ms-error.png'),
    },
    [REMOTE_DESKTOP_TYPE.VMWARE_VIEW]: {
        icon: makeFullPath('icon-rd-vmw.png'),
        iconError: makeFullPath('icon-rd-vmw-error.png'),
    },
};

class VdiModel extends WebtopResourceModel {
    static readonly propNames = ['termtype', 'auto_launch', 'auto_logon', ...WebtopResourceModel.propNames];

    type: RESOURCE.REMOTE_DESKTOP = RESOURCE.REMOTE_DESKTOP;
    rdType: REMOTE_DESKTOP_TYPE = REMOTE_DESKTOP_TYPE.NONE;

    autoLaunch: boolean = false;
    /**
     * autoLogon flag means the VDI resource is either configured to use SSO
     * or has valid credentials for current session.
     */
    autoLogon: boolean = false;

    folder?: string;
    parent?: string;

    vdiLogoffUrl?: string;
    numOfAppsLaunched: number = 0;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);

        this.autoLaunch = resource.props.auto_launch === '1';
        this.autoLogon = resource.props.auto_logon === '1' || isFavoriteVisited(id);

        this.rdType = resource.props.termtype as REMOTE_DESKTOP_TYPE;

        this.folder = resource.props.folder;
        this.parent = resource.props.parent;

        this.setRemoteDesktopIcons();
    }

    setRemoteDesktopIcons() {
        this.icon = this.icon ? this.icon : REMOTE_DESKTOP_TYPE_ICONS[this.rdType].icon;
    }

    getPropNames() {
        return VdiModel.propNames;
    }
}

export { REMOTE_DESKTOP_TYPE, VdiModel as default };
